<template>
  <div>
    <v-container fluid>
      <v-card class="elevation-0">
        <v-card-title>
          <v-layout row wrap justify-space-around align-center>
            <v-flex xs4 text-xs-center v-if="homeTeam && awayTeam">
              <v-avatar :size="85" color="white">
                <v-icon v-if="!homeTeam.team_logo" :size="56" color="grey lighten-1">fa-shield-alt</v-icon>
                <v-img
                  v-if="homeTeam.team_logo"
                  aspect-ratio="1"
                  style="border-radius: 12px"
                  contain
                  :src="homeTeam.team_logo"
                  alt="alt"
                />
              </v-avatar>
              <h2 class="text-xs-center">{{homeTeam.team_name}}</h2>
              <v-text-field
                class="mt-1"
                style="font-size:26px"
                outline
                hide-details
                :value="scoreA"
                readonly
                single-line
              ></v-text-field>
            </v-flex>
            <v-flex xs4 text-xs-center>
              <div class="display-3">X</div>
            </v-flex>
            <v-flex xs4 text-xs-center>
              <v-avatar :size="85" color="white">
                <v-icon v-if="!awayTeam.team_logo" :size="56" color="grey lighten-1">fa-shield-alt</v-icon>
                <v-img
                  v-if="awayTeam.team_logo"
                  aspect-ratio="1"
                  style="border-radius: 12px"
                  contain
                  :src="awayTeam.team_logo"
                  alt="alt"
                />
              </v-avatar>
              <h2 class="text-xs-center">{{awayTeam.team_name}}</h2>
              <v-text-field
                class="mt-1"
                style="font-size:26px"
                outline
                hide-details
                :value="scoreB"
                readonly
                single-line
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-card class="elevation-0" v-if="tieBreakersA!=0 || tieBreakersB != 0">
        <v-card-text>
          <v-layout row wrap justify-space-around align-center>
            <v-flex xs4 text-xs-center class="title">+ {{tieBreakersA}}</v-flex>
            <v-flex xs4 text-xs-center class="title">Desempate</v-flex>
            <v-flex xs4 text-xs-center class="title">+ {{tieBreakersB}}</v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    scoreA() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered.length;
    },
    scoreB() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered.length;
    },
    tieBreakersA() {
      var filtered = [];
      if (this.breakerPapers) {
        filtered = this.breakerPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered.length;
    },
    tieBreakersB() {
      var filtered = [];
      if (this.breakerPapers) {
        filtered = this.breakerPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered.length;
    },
    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    ...mapState({
      goalPapers: state => state.Match.goalPapers,
      breakerPapers: state => state.Match.breakerPapers
    })
  },
  created() {},

  watch: {}
};
</script>

<style scoped>
</style>